import { httpClient } from "@/services/http/client";

/** H3: the server's answer for "may this device play video now?". */
export type PlaybackLeaseAnswer =
  { playing: true; ttlSec: number; renewSec: number } | { playing: false; reason: "OTHER_DEVICE" };

/** `takeOver: true` when the student presses play here; `false` for the renewals while playing. */
export async function postPlaybackLease(takeOver: boolean): Promise<PlaybackLeaseAnswer> {
  const res = await httpClient.post<{ data: PlaybackLeaseAnswer }>("/v1/playback/lease", {
    takeOver,
  });
  return res.data.data;
}
